export const POPOVER_GAEVENT_CONSTS = {
	clickEditButton: 'clickEditButton',
	closeButton: 'closeButton',
	createSavedSearchButton: 'createSavedSearchButton',
	hoverEditButton: 'hoverEditButton',
	hoverShowVehiclesButton: 'hoverShowVehiclesButton',
};
